import LoggedInHOC from 'components/HOC/LoggedInHOC';
import RegisterHOC from 'components/HOC/RegisterHOC';
import {
  PaymentPage,
  PatientPage,
  HospitalInfoPage,
  ReservationPage,
  FormPage,
  PasswordSettingPage,
  RegisterHospitalPage,
  FormCreationPage,
  FormResultDetailPage,
  FormCollectionCreationPage,
  FormSubmitPage,
  ProtocolCreationPage,
  ProtocolDetailPage,
  FormsetDetailPage,
  FormResultListPage,
} from 'pages';

const routes = [
  { path: '/accounts/settings', component: PasswordSettingPage },
  {
    path: '/forms/collections/register',
    component: FormCollectionCreationPage,
  },
  {
    path: '/forms/collections/:collectionId',
    component: FormCollectionCreationPage,
  },
  { path: '/forms/protocols/register', component: ProtocolCreationPage },
  { path: '/forms/protocols/:id', component: ProtocolDetailPage },
  { path: '/forms/register', component: FormCreationPage },
  { path: '/results/:id', component: FormResultDetailPage },
  { path: '/forms/submits/:id', component: FormSubmitPage },
  { path: '/results', component: FormResultListPage },
  { path: '/forms/:id', component: FormsetDetailPage },
  { path: '/forms', component: FormPage },
  { path: '/patients', component: PatientPage },
  {
    path: '/hospitals/register',
    component: RegisterHospitalPage,
    needRegister: false,
  },
  {
    path: '/hospitals',
    component: HospitalInfoPage,
  },
  {
    path: '/reservations',
    component: ReservationPage,
  },
  {
    path: '/payments',
    component: PaymentPage,
  },
];

const PrivateRoutes = routes.map(({ component, needRegister = true, path }) => {
  return {
    path,
    component: LoggedInHOC(RegisterHOC(component, needRegister), true),
  };
});

export default PrivateRoutes;
